import { sgSupabase } from "../../lib/sgSupabaseClient";

export interface SgCounts {
  users: number;
  devices: number;
}

export async function fetchSgCounts(): Promise<SgCounts> {
  const [usersRes, devicesRes] = await Promise.all([
    sgSupabase.from("users").select("id", { count: "exact", head: true }),
    sgSupabase.from("devices").select("id", { count: "exact", head: true }),
  ]);
  return {
    users: usersRes.count ?? 0,
    devices: devicesRes.count ?? 0,
  };
}
